import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {  VendorsService } from 'src/app/Services/vendors.service';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';
// import { VendorsService } from '../../Services/vendors.service';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.scss']
})
export class VendorsComponent implements OnInit , AfterViewInit {
//#region Public Variabls
   environmentVariables:any;
   lang:any;
    nameRouting: any = [];
    allVendors: any = [];
    currentPage :any;
    totalPage: number = 0;
//#endregion

  constructor(
       public embryoService: EmbryoService,
        private translate: TranslateService,
        private confgServ: StaticPagesService,
        private cdRef: ChangeDetectorRef,
        private vendorsService: VendorsService,
         

  ) { 

    this.getInitilizingData();
           embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
         
        });
  }

  getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }


  ngOnInit(): void {
    // console.log(11);
    
    this.getvendors(1);
  }

    ngAfterViewInit(): void {
     this.nameRouting.push({name_en: 'vendors', name_ar: 'البائعين'})
        this.cdRef.detectChanges();
  }


  getvendors(page:any){
     this.vendorsService.getVendors(page).subscribe(res=>{
        //  console.log(res);t
        this.allVendors = res.data;
     })
  }


 
      onPageChanged(pageNumber: number) {
        this.currentPage = pageNumber;
        this.getvendors(this.currentPage);
    }
}
